import create from 'zustand';
import searchApi from 'lib/api/search';
import produce from 'immer';
import { Company } from '../../../../../../../../@types/company';

interface ISearchCompanyState {
  isLoading: boolean;
  data: Company[];
  hasMoreCompany: boolean;
}

interface ISearchCompanyAction {
  fetch: (query: string, page: number) => Promise<void>;
}

type ISearchCompanyStore = ISearchCompanyState & ISearchCompanyAction;

const initialState: ISearchCompanyState = {
  isLoading: false,
  data: [],
  hasMoreCompany: false,
};

const searchCompanyStore = create<ISearchCompanyStore>((set) => ({
  ...initialState,
  fetch: async (query, page) => {
    if (query.length > 1) {
      set({ isLoading: true });
      const res = await searchApi.getSearchCompany(query, page);

      if (!res.data) {
        throw new Error('Error while search company data');
      }

      const { data, message, error_type, error } = res.data;

      if (error || error_type) {
        throw new Error(message);
      }

      set(
        produce((state: ISearchCompanyStore) => {
          state.data = data.company;
          state.hasMoreCompany =
            data.pagination.has_more_companies;
          state.isLoading = false;
        }),
      );
    } else {
      set({ ...initialState });
    }
  },
}));

interface ISelectedSymbolStore {
  symbols: string[];
  updateSymbols: (symbol: string[]) => void;
}

const selectedSymbolStore = create<ISelectedSymbolStore>((set) => ({
  symbols: [],
  updateSymbols: (symbols: string[]) => {
    set({ symbols });
  },
}));

export {
 searchCompanyStore,
 selectedSymbolStore,
};
